import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useI18nStore } from "@companion-core/shared/app/Store/i18nStore";
import {
  containsSupportedDynamicPlaceholder,
  PersonnalizeDynamicContent,
  personnalizeObjectStringFields,
} from "@companion-core/shared/app/Utils/componentHelper";
import { useMemberData } from "@companion-core/shared/app/Hooks/member";

export const usePersonalizeField = () => {
  const { t } = useTranslation();
  const { locale: lang } = useI18nStore((state) => ({ locale: state.locale }));
  const { data: memberData } = useMemberData();

  const memberVars = useMemo(
    () => ({
      firstname: memberData?.firstname ?? null,
      lastname: memberData?.lastname ?? null,
      salutation: memberData?.salutation ?? null,
      addresses: memberData?.addresses ?? [],
    }),
    [memberData?.firstname, memberData?.lastname, memberData?.salutation, memberData?.addresses]
  );

  const personalizeField = useCallback(
    (value?: string | null) => {
      if (typeof value !== "string" || !containsSupportedDynamicPlaceholder(value)) return value;
      return PersonnalizeDynamicContent(value, memberVars, t, lang);
    },
    [memberVars, t, lang]
  );

  const personalizeObject = useCallback(
    <T>(value: T): T => {
      return personnalizeObjectStringFields(value, memberVars, t, lang) as T;
    },
    [memberVars, t, lang]
  );

  return { personalizeField, personalizeObject };
};
